import { Accordion } from '@/components/ui/Accordion';
import styles from '@/styles/components/RecipePage.module.css';

function StarterCreationContent() {
  return (
    <div className={styles.recipeContent}>
      <h3 className={styles.sectionTitle}>Ingredients</h3>
      <ul className={styles.ingredientList}>
        <li>1 envelope yeast (or <span className={styles.highlight}>2 tsp / 7g</span> active dry yeast)</li>
        <li>1 cup warm water (<span className={styles.highlight}>120°F</span>)</li>
        <li><span className={styles.highlight}>3/4 cup</span> sugar</li>
        <li><span className={styles.highlight}>4 Tbsp</span> instant potato flakes</li>
      </ul>

      <h3 className={styles.sectionTitle}>Instructions</h3>
      <ol className={styles.stepList}>
        <li>Mix all ingredients together</li>
        <li>Cover loosely and let stand at room temperature for <span className={styles.highlight}>24 hours</span></li>
        <li>Put in fridge for <span className={styles.highlight}>3-5 days</span></li>
        <li>On day 4, feed the starter (see Feeding Instructions)</li>
        <li>Continue following the feeding schedule</li>
      </ol>

      <div className={styles.tip}>
        <strong>Note:</strong> 1 pkg (1/4 oz) active dry yeast = 2 tsp = 7g
      </div>
    </div>
  );
}

function FeedingInstructionsContent() {
  return (
    <div className={styles.recipeContent}>
      <h3 className={styles.sectionTitle}>Feed with:</h3>
      <ul className={styles.ingredientList}>
        <li><span className={styles.highlight}>3/4 cup</span> Sugar</li>
        <li><span className={styles.highlight}>1 cup</span> Warm Water</li>
        <li><span className={styles.highlight}>3 Tbsp</span> Instant Potato Flakes</li>
      </ul>

      <p>
        Feed <span className={styles.emphasis}>every three to five days</span>. You must feed at
        least <span className={styles.emphasis}>every seven days</span>.
      </p>
      <p>
        The day you feed dough, let it stand on counter covered all day (
        <span className={styles.highlight}>8-12 hours</span>). Take one cup of starter to make a
        batch. Return the rest to the refrigerator with a lid on it.
      </p>
      <p>
        If not making a batch, throw away one cup dough or give away to avoid deflating.
      </p>
    </div>
  );
}

function BreadRecipeContent() {
  return (
    <div className={styles.recipeContent}>
      <h3 className={styles.sectionTitle}>Ingredients</h3>
      <ul className={styles.ingredientList}>
        <li><span className={styles.highlight}>1 cup</span> Starter Dough</li>
        <li><span className={styles.highlight}>1/4 cup</span> Sugar</li>
        <li><span className={styles.highlight}>1/2 cup</span> Corn Oil</li>
        <li><span className={styles.highlight}>2 tsp</span> Salt</li>
        <li><span className={styles.highlight}>1 1/2 cups</span> Warm Water</li>
        <li><span className={styles.highlight}>6 cups</span> Bread Flour <span className={styles.emphasis}>(must use bread flour)</span></li>
      </ul>

      <h3 className={styles.sectionTitle}>Instructions</h3>
      <ol className={styles.stepList}>
        <li>
          <span className={styles.emphasis}>Mix:</span> Mix the ingredients well in one bowl.
        </li>
        <li>
          <span className={styles.emphasis}>First Rise:</span> Grease another large bowl and put
          dough in. Turn dough to grease all sides of dough. Cover and let rise{' '}
          <span className={styles.highlight}>overnight</span> on counter top.
        </li>
        <li>
          <span className={styles.emphasis}>Knead:</span> The next morning, punch down and knead 10
          times. Divide into three equal parts.{' '}
          <span className={styles.emphasis}>(One batch makes three loaves.)</span> Knead each on
          floured surface 10-12 times. (It doesn&apos;t take much flour on board.)
        </li>
        <li>
          <span className={styles.emphasis}>Second Rise:</span> Put into greased pans and cover with
          plastic wrap. Let rise <span className={styles.highlight}>four to five hours</span> or
          overnight.
        </li>
        <li>
          <span className={styles.emphasis}>Bake:</span> Bake at{' '}
          <span className={styles.highlight}>350°F</span> for{' '}
          <span className={styles.highlight}>20-25 minutes</span>.
        </li>
      </ol>

      <div className={styles.tip}>
        <strong>Tip:</strong> Put in oven with light on for a warm proofing environment.
      </div>
    </div>
  );
}

export function RecipePage() {
  const recipeItems = [
    {
      value: 'starter-creation',
      trigger: 'Starter Creation',
      content: <StarterCreationContent />,
    },
    {
      value: 'feeding',
      trigger: 'Feeding Instructions',
      content: <FeedingInstructionsContent />,
    },
    {
      value: 'bread-recipe',
      trigger: 'Bread Recipe',
      content: <BreadRecipeContent />,
    },
  ];

  return (
    <div className={styles.page}>
      <Accordion items={recipeItems} defaultValue="feeding" />
    </div>
  );
}
